// Project:      Vision ANPR - Job Upload Widget
// Author:       Leon du Plooy - Castle Traffic Ltd
// Contact:      dev@castle-traffic.co.uk
// Created:      2025-07-08
//
// Description:  Upload widget for job files with EXIF metadata preview.

import React, { useState } from "react";
import EXIF from "exif-js";

const JobFileUploadWidget = () => {
  const [files, setFiles] = useState([]);
  const [metadata, setMetadata] = useState([]);

  const handleFileSelect = (e) => {
    const newFiles = Array.from(e.target.files);
    setFiles((prev) => [...prev, ...newFiles]);

    newFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = function () {
        const buffer = reader.result;
        EXIF.getData({ src: buffer }, function () {
          const meta = {
            name: file.name,
            size: file.size,
            date: EXIF.getTag(this, "DateTimeOriginal") || "N/A",
            lat: EXIF.getTag(this, "GPSLatitude")?.toString() || "N/A",
            lon: EXIF.getTag(this, "GPSLongitude")?.toString() || "N/A",
          };
          setMetadata((prev) => [...prev, meta]);
        });
      };
      reader.readAsArrayBuffer(file);
    });
  };

  return (
    <div
      style={{
        padding: "16px",
        border: "2px dashed #ccc",
        borderRadius: "12px",
        background: "#fff",
        height: "100%",
        overflowY: "auto",
      }}
    >
      <h3 className="text-lg font-semibold mb-2">Upload Files with EXIF Preview</h3>
      <input
        type="file"
        multiple
        onChange={handleFileSelect}
        style={{
          padding: "10px",
          border: "1px solid #ddd",
          borderRadius: "6px",
          marginBottom: "12px",
        }}
      />
      <div>
        {metadata.map((meta, idx) => (
          <div
            key={idx}
            style={{
              marginBottom: "10px",
              padding: "10px",
              backgroundColor: "#f9f9f9",
              borderRadius: "6px",
              fontSize: "0.9rem",
            }}
          >
            <div><strong>{meta.name}</strong> ({(meta.size / 1024).toFixed(1)} KB)</div>
            <div>Date: {meta.date}</div>
            <div>Lat: {meta.lat}</div>
            <div>Lon: {meta.lon}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default JobFileUploadWidget;
